import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import styles from "./styles.css";
import PostInspectionDiyAuctionImpressions from "../post-inspection-diy-auction-impressions";
import { NUMBER } from "../../../constants/app-constants";
const PostInspectionDiyImpressionsMap = loadable(() => import("../post-inspection-diy-impressions-map"));

const PostInspectionDiyAuctionTimerWrapper = ({
    getUpdatedDiyDetailsConnect,
    inspectionResponse,
    clockTimer,
    googlemap = false,
    similarCarSoldCount = NUMBER.FIFTY
}) => {
    const { token, impressionsCount, impressionData, featureData = {} } = inspectionResponse || {};
    const { dealerImpressionEnabled = false } = featureData || {};
    const [showMap, setShowMap] = useState(false);
    const [time, setTime] = useState(clockTimer);

    const hrs = `${Math.floor(time / (NUMBER.THIRTY_SIX * NUMBER.HUNDRED))}`.padStart(NUMBER.TWO, 0);
    const minutes = `${Math.floor(time / NUMBER.SIXTY) % NUMBER.SIXTY}`.padStart(NUMBER.TWO, 0);
    const seconds = `${time % NUMBER.SIXTY}`.padStart(NUMBER.TWO, 0);

    useEffect(() => {
        const timer = window.setInterval(() => {
            setTime((prevTime) => {
                if (prevTime === 0) {
                    window.clearInterval(timer);
                    return 0;
                } else return prevTime - 1;
            });
        }, NUMBER.THOUSAND);
    }, []);

    useEffect(() => {
        if (time <= NUMBER.ZERO) {
            getUpdatedDiyDetailsConnect(token, <span>Generating price <br/> for your car</span>);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [time]);

    const toggleMapHandler = () => {
        setShowMap(prev => !prev);
    };

    return (
        <div styleName={"styles.auctionTimerWrapper"}>
            {
                showMap ?
                    <PostInspectionDiyImpressionsMap
                        auctionTime={{hrs, minutes, seconds}}
                        time={time}
                        toggleMapHandler={toggleMapHandler}
                        impressionData={impressionData}
                    /> :
                    <PostInspectionDiyAuctionImpressions
                        auctionTime={{hrs, minutes, seconds}}
                        impressionCount={impressionsCount}
                        carSoldCount={similarCarSoldCount}
                        time={time}
                        toggleMapHandler={toggleMapHandler}
                        googlemap={googlemap}
                        impressions={impressionData}
                        dealerImpressionEnabled={dealerImpressionEnabled}
                    />
            }
        </div>
    );
};

PostInspectionDiyAuctionTimerWrapper.propTypes = {
    googlemap: PropTypes.bool,
    auctionEndTime: PropTypes.string,
    clockTimer: PropTypes.string,
    getUpdatedDiyDetailsConnect: PropTypes.func,
    inspectionResponse: PropTypes.string,
    similarCarSoldCount: PropTypes.number,
    impression: PropTypes.object,
    totalImpression: PropTypes.number
};

export default PostInspectionDiyAuctionTimerWrapper;

